export const AI_RED_DOT_DETECTED_EVENT = 'qx-ai-red-dot-detected'

export function hasContentId(items: Array<{ contentId?: string }>, contentId?: string): boolean {
  return Boolean(contentId && items.some((item) => String(item.contentId) === String(contentId)))
}

export function findOptimisticUserMatch(
  items: Array<{ role: string; content: string; contentId?: string; timestamp: number }>,
  incoming: { role: string; content: string; timestamp: number },
): number {
  if (incoming.role !== 'user') return -1
  const normalized = incoming.content.trim()
  for (let index = items.length - 1; index >= 0; index--) {
    const candidate = items[index]
    if (!candidate || candidate.role !== 'user' || candidate.contentId || candidate.content.trim() !== normalized) continue
    const next = items[index + 1]
    if (!next || next.role !== 'assistant') continue
    if (Math.abs(candidate.timestamp - incoming.timestamp) <= 5 * 60 * 1000) return index
  }
  return -1
}

export function shouldRenderChatMessage(message: {
  role: string
  content?: string
  messageType?: string
  status?: number
  isStreaming?: boolean
  error?: string
}): boolean {
  if (message.role !== 'assistant') return true
  if (message.status === 3) return false
  if (message.messageType === 'CARD') return true
  return Boolean(message.content?.trim() || message.isStreaming || message.error)
}

export function shouldRemoveEmptyAssistantAfterSettlement(message: {
  role: string
  content?: string
  error?: string
}): boolean {
  return message.role === 'assistant' && !message.content?.trim()
}
